export default __webpack_public_path__ + "static/media/hotel_overseas_1.98285ac7.jpeg";